import { render, staticRenderFns } from "./ErrorLayout.vue?vue&type=template&id=4d110a53&scoped=true"
import script from "./ErrorLayout.vue?vue&type=script&lang=ts"
export * from "./ErrorLayout.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d110a53",
  null
  
)

export default component.exports